
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexXmop3J06pJr03MEIXx8I_F_eOZL_wG4InmTWZU6IPpQMeta } from "/builds/escapadarural/rurality-nuxt/pages/index.vue?macro=true";
import { default as indexZwlfTotpMWEgu9ObrgtTprrbca2jrhM_cSxHPGfsZn8Meta } from "/builds/escapadarural/rurality-nuxt/pages/login/index.vue?macro=true";
import { default as indexJdqvNgEPCFBnEBf0uldkhGo3t8zPCv1JxSucF5eaRBwMeta } from "/builds/escapadarural/rurality-nuxt/pages/owner/[[id]]/online-booking/dsa/index.vue?macro=true";
import { default as index_46client4v3PXQOk7cFLRrUEyeKmU1F9fCcwwOgY4a3vO21qIX4Meta } from "/builds/escapadarural/rurality-nuxt/pages/owner/[[id]]/quality-rate/index.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/builds/escapadarural/rurality-nuxt/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as index_46clientlVBND28z8QsBrM1lv4sLrxzCMSqo_5basaI8KACtf40Meta } from "/builds/escapadarural/rurality-nuxt/pages/owner/[[id]]/calendar/avaibook/index.client.vue?macro=true";
import { default as indexSCFztOQZCQyxj7OtkxvWDyIxPph5PgXL86Sa4GZf878Meta } from "/builds/escapadarural/rurality-nuxt/pages/owner/[[id]]/menu/services/legal-info/index.vue?macro=true";
import { default as index_46clientEBeHTgd7vMcJ8aAQk9xpZm_45LqWLoEvZOMm_RnHoJrxQMeta } from "/builds/escapadarural/rurality-nuxt/pages/owner/[[id]]/menu/services/dac7/index.client.vue?macro=true";
import { default as index_46clientFYIkJHJLtQoiW67HzQK6_45KsEzeOBokLIXF6Gty9AWWUMeta } from "/builds/escapadarural/rurality-nuxt/pages/owner/[[id]]/calendar/misterplan/index.client.vue?macro=true";
import { default as indexEeqbKLmfZruOxUesz_45pgY6RMwJrupuDNxBe06Kuj7AMMeta } from "/builds/escapadarural/rurality-nuxt/pages/owner/[[id]]/menu/services/legal-info/edit/index.vue?macro=true";
import { default as index_46clienteEte3Cv3lvPSzQTjgfQoUsVD7BxJpR_45a96YH_WJKnnsMeta } from "/builds/escapadarural/rurality-nuxt/pages/owner/[[id]]/calendar/sync/[[rentUnitId]]/index.client.vue?macro=true";
import { default as index1AGhlUn1x04MyrFGwLDhRy3ilYQM1EcCPGffrjWLs1IMeta } from "/builds/escapadarural/rurality-nuxt/pages/owner/[[id]]/menu/whatsapp/view/[type]/[idwhatsapp]/index.vue?macro=true";
import { default as index_46clientrzeGWyNMPibOUYwhVpiX8DioKwXwtBf7hmegDkKGr2YMeta } from "/builds/escapadarural/rurality-nuxt/pages/owner/[[id]]/calendar/sync/[[rentUnitId]]/new/index.client.vue?macro=true";
import { default as _91_91id_93_93h_45CUlifDHrEkwQ58qYKySil6JjGlCGoBeSrO35mFTvEMeta } from "/builds/escapadarural/rurality-nuxt/pages/owner/[[id]].vue?macro=true";
import { default as index5OkrvkoNPfyXDo9UlAWvFXfNYNXkRTkaxSRImwIzGi0Meta } from "/builds/escapadarural/rurality-nuxt/pages/pueblos/index.vue?macro=true";
import { default as __links_46client8Pspymy2q4opnKELZdRaVPpBgV0ZcODzOHTzIeRMWOMMeta } from "/builds/escapadarural/rurality-nuxt/pages/__links.client.vue?macro=true";
import { default as _91slug_938cu9l2v9kvwqoUFr9QlnupQbwoCSNXoR1vQOFQZFEN0Meta } from "/builds/escapadarural/rurality-nuxt/pages/campana/[slug].vue?macro=true";
import { default as indexGKlAZOWDv6xHsufVHg5k_sz7V_45vxg_qJtt7dArbuL1cMeta } from "/builds/escapadarural/rurality-nuxt/pages/contacto/index.vue?macro=true";
import { default as indexzT4j2TWTD7HLNi_d2KjDYAvLDKUx1oeOGv2xP4TeD7wMeta } from "/builds/escapadarural/rurality-nuxt/pages/escapadas/index.vue?macro=true";
import { default as index_46client8X24Ih2xaLFscIKUG4cttzl2gdBNyDDjbNl3Kx7kPOsMeta } from "/builds/escapadarural/rurality-nuxt/pages/traveler/[[id]]/menu/messages/index.client.vue?macro=true";
import { default as _91_91id_93_938bcUwAPphd0euEBawEHm88JPez9XLLCahKWYHGRr7xwMeta } from "/builds/escapadarural/rurality-nuxt/pages/traveler/[[id]].vue?macro=true";
import { default as indexoC9ULLRR5Ego1IDsM0BPygR7r90h0pcQO2UD4N_45RlPgMeta } from "/builds/escapadarural/rurality-nuxt/pages/signup-app/index.vue?macro=true";
import { default as indexu2HhjSdyRdGJEsbRYCwdLGMm0abIPqe_45UCuEmVLEgggMeta } from "/builds/escapadarural/rurality-nuxt/pages/vacaciones/index.vue?macro=true";
import { default as hashmu83FpsNl3x9ygc9bHWMVF_68dpAJwtzv8dGQPKyaF0Meta } from "/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/hash.vue?macro=true";
import { default as indexWo6YjNw8xQV_6x7zkWLlKGVJwytUI1snquDfWiSIjLQMeta } from "/builds/escapadarural/rurality-nuxt/pages/aviso-legal/index.vue?macro=true";
import { default as indexCgWN3MtCV6dL6QHHKk8Sn0czq6U3V2ounZNcZS1YcAkMeta } from "/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/index.vue?macro=true";
import { default as indexB9_45R5KEcVvdP0_45fdEiywxcT7Ivx24jvyUnN51mazlfAMeta } from "/builds/escapadarural/rurality-nuxt/pages/propietario/[[id]]/menu/invita-seleccion/index.vue?macro=true";
import { default as index_46clientuP3GCz1SRvEoFvNXyR2fvB9XMczh_qs9dkoZ0t_452NDAMeta } from "/builds/escapadarural/rurality-nuxt/pages/propietario/[[id]]/casa/[cottageId]/legal/index.client.vue?macro=true";
import { default as index_46clientGgsG7Wr1SigLg_45eSsbXepQKQToR_z9_45_45tEmCR3ovDGcMeta } from "/builds/escapadarural/rurality-nuxt/pages/propietario/[[id]]/casa/[cottageId]/editar/fotos/index.client.vue?macro=true";
import { default as _91_91id_93_93K9LDMmaYdWABMFM2Jibvq43atLGCLAwtx8w6batT_ecMeta } from "/builds/escapadarural/rurality-nuxt/pages/propietario/[[id]].vue?macro=true";
import { default as errorsnq4RpbNsmdwhw8mac61xXIsvDvv2X8WqstZfwdWBRo4Meta } from "/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/errors.vue?macro=true";
import { default as healthtuUnMOEI7MUYshPbxK3_bI1lfhC4cQ0OTYB6Fd1j4NwMeta } from "/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/health.vue?macro=true";
import { default as index5zn_45IzLKTZjbtzy2MKF6MQh4TTte7sxdMnUtTC5VP1kMeta } from "/builds/escapadarural/rurality-nuxt/pages/accesibilidad/index.vue?macro=true";
import { default as indexAH0y7NP_bUbvRQeaHdevtmDCqjl6d9ikCcT9TvUH8eIMeta } from "/builds/escapadarural/rurality-nuxt/pages/casas-rurales/index.vue?macro=true";
import { default as index0ahjPYcnDpQW6jvT6m2R4pPippImXOwUwPpvo44T4zMMeta } from "/builds/escapadarural/rurality-nuxt/pages/pueblos/[slug]/index.vue?macro=true";
import { default as indexmRkmXf_tRKbbGkfdqs975U5ZtZ7w_45hm9D92QKjhd930Meta } from "/builds/escapadarural/rurality-nuxt/pages/destinos/[slug]/index.vue?macro=true";
import { default as nuxt_45ui_4529zijkz_45hA_45DK_45YgVAl7Uu6RZ4moY_dg5tyA7tqxRKJkMeta } from "/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/nuxt-ui-2.vue?macro=true";
import { default as index5PNdiqCZgo0zWDMBHwzJrrMkRZJ5IdJGBjWncgFCIV0Meta } from "/builds/escapadarural/rurality-nuxt/pages/escapadas/[slug]/index.vue?macro=true";
import { default as indexrRcrzY_45Rpy6nwggyE75xu3qc8jzYH841Jj6Fq_45VUotwMeta } from "/builds/escapadarural/rurality-nuxt/pages/viajero/registro/index.vue?macro=true";
import { default as nuxt_45image8us3OoaZZD98gys3cTZBgC87DA54YSiuqKiLTqO5_ssMeta } from "/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/nuxt-image.vue?macro=true";
import { default as index_45BXavkmdl4Qq0iuYOL63yhdLssTX6E64CjMk_hXRmPIMeta } from "/builds/escapadarural/rurality-nuxt/pages/vacaciones/[slug]/index.vue?macro=true";
import { default as indexzioCOUGf1mn8yglD1bWAlPRPbzk7uoR8dv0vgAZdqq0Meta } from "/builds/escapadarural/rurality-nuxt/pages/politica-privacidad/index.vue?macro=true";
import { default as indexqQO9dkgosqF99ui3o8V70RMRMtuTfm4IkSOTOEGBy_oMeta } from "/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/index.vue?macro=true";
import { default as paletteuZziaK1w9Sc3rrfoJawCyVy7HMHL_i6xbawqcvpqLj0Meta } from "/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/nuxt-ui/palette.vue?macro=true";
import { default as u_45card_46clientr37oDhoIxYubx3Rv48EUj86zGCZVJpTuis_45UxYSpsE4Meta } from "/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/nuxt-ui/u-card.client.vue?macro=true";
import { default as u_45badge_46client7sADnaiEwBeSOjbd_45zLCQNjurLaiMFZt7lcrgM3DiTMMeta } from "/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/nuxt-ui/u-badge.client.vue?macro=true";
import { default as u_45input_46clientrODPU1gvDU4tPkGq_459XQQ5Q_45dlr2vq5fXTO8jenVJTYMeta } from "/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/nuxt-ui/u-input.client.vue?macro=true";
import { default as u_45button_46clientycRfJQRYmPxCPZGUGa0gjR7uigpJGFw0V3F79NpPEyQMeta } from "/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/nuxt-ui/u-button.client.vue?macro=true";
import { default as t_45prose_46clientJwNg5clQwF4Xv5TaGlmpGuuawHL5G2h00bhfOSW6L9QMeta } from "/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/components/t-prose.client.vue?macro=true";
import { default as t_45title_46clientFXSU0EdtWDjP_45CbCQHqDawv4te_45WlXLWQWLPsEshIhEMeta } from "/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/components/t-title.client.vue?macro=true";
import { default as s_45section_46client2A5zilpDg2nrbMZkn0lJ7tLkat7Xt1_45Uxv5OjMMjXJ8Meta } from "/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/sections/s-section.client.vue?macro=true";
import { default as u_45accordion_46clientmKPkXlkc60x_84e98p_45vJKAgdoaxbDGBfuTrSd1o_O0Meta } from "/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/nuxt-ui/u-accordion.client.vue?macro=true";
import { default as s_45cta_45card_46clientSnyEd9WEDgtYFxUMFjXNEBDeoZW_DfzEgrwBh19ZaSwMeta } from "/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/sections/s-cta-card.client.vue?macro=true";
import { default as s_45hero_45card_46clientNjq95WhKTzr4pL38070C42pNri3uf9E1fRwSScxpxkgMeta } from "/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/sections/s-hero-card.client.vue?macro=true";
import { default as s_45hero_45angled_46clientvzn_45wQUWBgezPzxMHV1Y6MjkcvDXpB3DXh03Ok68VR8Meta } from "/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/sections/s-hero-angled.client.vue?macro=true";
import { default as t_45image_45info_46clientJ2KU7P_rv7_456aMdCQEzXdbYGmfShHhnb7aA_45xUDZZdIMeta } from "/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/components/t-image-info.client.vue?macro=true";
import { default as s_45media_45banner_46clientVzkisVBL2g6J0xs7off75oki445NUiRyq3BKwBKYbd8Meta } from "/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/sections/s-media-banner.client.vue?macro=true";
import { default as t_45modal_45close_46clientX_45PqzbxnY93p_45F4AJ2QELicHxBTlQAfwn9R6dQDizcgMeta } from "/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/components/t-modal-close.client.vue?macro=true";
import { default as s_45section_45color_46clientO_45LzbTgiIJUXoEqEddVV4bQduI_45_45Q3Gut1xm6wB3EZoMeta } from "/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/sections/s-section-color.client.vue?macro=true";
import { default as s_45section_45split_46clientQEZ8zBcL_45t8ARYTzQR8UydisjSpoNpP_CNRNtdKO7_4Meta } from "/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/sections/s-section-split.client.vue?macro=true";
import { default as s_45simple_45banner_46clientAOUUYxN88S8D74jvD7aTYx_45dpM6_45s_45xYEH3wDsslOqQMeta } from "/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/sections/s-simple-banner.client.vue?macro=true";
import { default as t_45modal_45header_46clientZMrEoNrH9h74xTkWGsY8LP_XLZCzZQAqNDfi2_45iTkI4Meta } from "/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/components/t-modal-header.client.vue?macro=true";
import { default as s_45cta_45color_45image_46clientH2upn9e1z2jeOisI6dn_nfP8zWpXcMjhpXZnJDXlYfcMeta } from "/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/sections/s-cta-color-image.client.vue?macro=true";
import { default as s_45hero_45card_45search_46clientJG53q9cVDvpM_45XvMl8K5g28tpB_P1l6WlEaeaBXxvYUMeta } from "/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/sections/s-hero-card-search.client.vue?macro=true";
import { default as design_45systemryTS8jm75JPnFdktbqAiDQv4Ehw_QQJLHmoRzOee5wYMeta } from "/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system.vue?macro=true";
import { default as nuxt_45ui_46client_8XEvmHuqJUrs5iTkOc03A_qyznter90c8DNdKlgmawMeta } from "/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/nuxt-ui.client.vue?macro=true";
import { default as indexGcYxHWdflEQUpa1Q6JlKD3OgDb0_45iDcHXHgIsY1lKsoMeta } from "/builds/escapadarural/rurality-nuxt/pages/propietario/casa/nueva/index.vue?macro=true";
import { default as indexzKRkF1TTuQMKZ54ykjXRuRySPRxn_Aeeo5pzmeOqzWQMeta } from "/builds/escapadarural/rurality-nuxt/pages/viajero/registro-optin/index.vue?macro=true";
import { default as internal_45trafficzhhIm65_OZtP3FTOacTjYMtSmbwf5sOW9xCR0zD9MtgMeta } from "/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/internal-traffic.vue?macro=true";
import { default as indexdmOI55HyE_45PEubZZ_OtPtPU_45sg0qNCgjnj7Ek8vOTwEMeta } from "/builds/escapadarural/rurality-nuxt/pages/como-funciona-la-plataforma/index.vue?macro=true";
import { default as indexhYyMZ8ulIgZuhJ8fMrq_45iFRtagvujlqhdKb8iEDSy7AMeta } from "/builds/escapadarural/rurality-nuxt/pages/todas-las-escapadas-rurales/index.vue?macro=true";
import { default as indexEUEkrSr21KN24VVeLH_45Ivdwp7yyo7ts2cY_vhI_45_eWgMeta } from "/builds/escapadarural/rurality-nuxt/pages/casa-rural/[province]/[slug]/index.vue?macro=true";
import { default as indexrfTw8l_b_45ky_gZdLUXkbfdLzn90z7WIvNir4_45lqJKF4Meta } from "/builds/escapadarural/rurality-nuxt/pages/casa-rural/[province]/[slug]/precios/index.vue?macro=true";
import { default as indexqIv27DsRrXPIKvyAlYlvHspHDqzyoj_JGeAZ_cL2F64Meta } from "/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/cottages/recommended/[id]/index.vue?macro=true";
import { default as index7AhgOQMtQ_45bL_ybgL3B9KgQUfZpDViNlI247V5e8XxYMeta } from "/builds/escapadarural/rurality-nuxt/pages/reserva-online/como-activar/prueba-nuxt-1/index.vue?macro=true";
import { default as indexnh50qxzHiOveyvSjRSeFYQxuhcxnNhi5DyFI5MlvndUMeta } from "/builds/escapadarural/rurality-nuxt/pages/reserva-online/como-funciona/prueba-nuxt-1/index.vue?macro=true";
import { default as _91id_93hOnUz_oYCzPOBe8dv5t8IH7zGbhrkN0_TjNADIdbZFQMeta } from "/builds/escapadarural/rurality-nuxt/pages/casa-rural/[province]/[slug]/solicitud/oferta/[id].vue?macro=true";
import { default as indexM64GENOhODaGYggtTpuNmFlaG4UHH2TAeNuF8o6kzFEMeta } from "/builds/escapadarural/rurality-nuxt/pages/private/casa-rural/[province]/[slug]/telefono/index.vue?macro=true";
import { default as indexOPPp4DpY6cQ0StbFh7gK9vmdPOD7EU_wbBwn7HnJ1NAMeta } from "/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/messages/whatsapp/[id]/[page]/[erck]/index.vue?macro=true";
import { default as indexmb_d_SJCCez8aNn6kP1wKYDl6WIZneqRUcDBg4arYbQMeta } from "/builds/escapadarural/rurality-nuxt/pages/casa-rural/[province]/[slug]/solicitud/pre-reserva/index.vue?macro=true";
import { default as indexJZ13Q6OBqNiaqoLyl9iSJMCPt6nLEO70LnM7RCZ1jlAMeta } from "/builds/escapadarural/rurality-nuxt/pages/casa-rural/[province]/[slug]/solicitud/contacto-email/index.vue?macro=true";
import { default as index8BBE1bmo286Aj31XKmkmJ05Lluw1EEjBnImKRKXE56gMeta } from "/builds/escapadarural/rurality-nuxt/pages/reserva-online/como-activar/prueba-nuxt-1/prueba-nuxt-2/index.vue?macro=true";
import { default as indexTXG1bj9XnkPPEMLLxAKwNTYYTgnyWHFAZyqgCCY7d_45UMeta } from "/builds/escapadarural/rurality-nuxt/pages/casa-rural/[province]/[slug]/solicitud/contacto-whatsapp/index.vue?macro=true";
import { default as indexmmQfCvEANtGCRoBR3DiEXuzlMUKOVnFO2i8OhZBikZkMeta } from "/builds/escapadarural/rurality-nuxt/pages/casa-rural/[province]/[slug]/solicitud/online-booking/[id]/index.vue?macro=true";
import { default as indexTIt3qgXWY2wij0J_45Lox6dKOph4dD1p3xWs7Rwqe7iqYMeta } from "/builds/escapadarural/rurality-nuxt/pages/casa-rural/[province]/[slug]/solicitud/online-booking/[id]/payment-success/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexXmop3J06pJr03MEIXx8I_F_eOZL_wG4InmTWZU6IPpQMeta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: indexZwlfTotpMWEgu9ObrgtTprrbca2jrhM_cSxHPGfsZn8Meta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/login/index.vue")
  },
  {
    name: "owner-id",
    path: "/owner/:id?",
    meta: _91_91id_93_93h_45CUlifDHrEkwQ58qYKySil6JjGlCGoBeSrO35mFTvEMeta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/owner/[[id]].vue"),
    children: [
  {
    name: "owner-id-online-booking-dsa",
    path: "online-booking/dsa",
    meta: indexJdqvNgEPCFBnEBf0uldkhGo3t8zPCv1JxSucF5eaRBwMeta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/owner/[[id]]/online-booking/dsa/index.vue")
  },
  {
    name: "owner-id-quality-rate",
    path: "quality-rate",
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/pages/owner/[[id]]/quality-rate/index.client.vue"))
  },
  {
    name: "owner-id-calendar-avaibook",
    path: "calendar/avaibook",
    meta: index_46clientlVBND28z8QsBrM1lv4sLrxzCMSqo_5basaI8KACtf40Meta || {},
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/pages/owner/[[id]]/calendar/avaibook/index.client.vue"))
  },
  {
    name: "owner-id-menu-services-legal-info",
    path: "menu/services/legal-info",
    meta: indexSCFztOQZCQyxj7OtkxvWDyIxPph5PgXL86Sa4GZf878Meta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/owner/[[id]]/menu/services/legal-info/index.vue")
  },
  {
    name: "owner-id-menu-services-dac7",
    path: "menu/services/dac7",
    meta: index_46clientEBeHTgd7vMcJ8aAQk9xpZm_45LqWLoEvZOMm_RnHoJrxQMeta || {},
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/pages/owner/[[id]]/menu/services/dac7/index.client.vue"))
  },
  {
    name: "owner-id-calendar-misterplan",
    path: "calendar/misterplan",
    meta: index_46clientFYIkJHJLtQoiW67HzQK6_45KsEzeOBokLIXF6Gty9AWWUMeta || {},
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/pages/owner/[[id]]/calendar/misterplan/index.client.vue"))
  },
  {
    name: "owner-id-menu-services-legal-info-edit",
    path: "menu/services/legal-info/edit",
    meta: indexEeqbKLmfZruOxUesz_45pgY6RMwJrupuDNxBe06Kuj7AMMeta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/owner/[[id]]/menu/services/legal-info/edit/index.vue")
  },
  {
    name: "owner-id-calendar-sync-rentUnitId",
    path: "calendar/sync/:rentUnitId?",
    meta: index_46clienteEte3Cv3lvPSzQTjgfQoUsVD7BxJpR_45a96YH_WJKnnsMeta || {},
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/pages/owner/[[id]]/calendar/sync/[[rentUnitId]]/index.client.vue"))
  },
  {
    name: index1AGhlUn1x04MyrFGwLDhRy3ilYQM1EcCPGffrjWLs1IMeta?.name ?? "owner-id-menu-whatsapp-view-type-idwhatsapp",
    path: "menu/whatsapp/view/:type()/:idwhatsapp()",
    meta: index1AGhlUn1x04MyrFGwLDhRy3ilYQM1EcCPGffrjWLs1IMeta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/owner/[[id]]/menu/whatsapp/view/[type]/[idwhatsapp]/index.vue")
  },
  {
    name: "owner-id-calendar-sync-rentUnitId-new",
    path: "calendar/sync/:rentUnitId?/new",
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/pages/owner/[[id]]/calendar/sync/[[rentUnitId]]/new/index.client.vue"))
  }
]
  },
  {
    name: "pueblos",
    path: "/pueblos",
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/pueblos/index.vue")
  },
  {
    name: "__links",
    path: "/__links",
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/pages/__links.client.vue"))
  },
  {
    name: "campana-slug",
    path: "/campana/:slug()",
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/campana/[slug].vue")
  },
  {
    name: "contacto",
    path: "/contacto",
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/contacto/index.vue")
  },
  {
    name: "escapadas",
    path: "/escapadas",
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/escapadas/index.vue")
  },
  {
    name: "traveler-id",
    path: "/traveler/:id?",
    meta: _91_91id_93_938bcUwAPphd0euEBawEHm88JPez9XLLCahKWYHGRr7xwMeta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/traveler/[[id]].vue"),
    children: [
  {
    name: "traveler-id-menu-messages",
    path: "menu/messages",
    meta: index_46client8X24Ih2xaLFscIKUG4cttzl2gdBNyDDjbNl3Kx7kPOsMeta || {},
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/pages/traveler/[[id]]/menu/messages/index.client.vue"))
  }
]
  },
  {
    name: "signup-app",
    path: "/signup-app",
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/signup-app/index.vue")
  },
  {
    name: "vacaciones",
    path: "/vacaciones",
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/vacaciones/index.vue")
  },
  {
    name: "__nuxt-pages-hash",
    path: "/__nuxt-pages/hash",
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/hash.vue")
  },
  {
    name: "aviso-legal",
    path: "/aviso-legal",
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/aviso-legal/index.vue")
  },
  {
    name: "__nuxt-pages",
    path: "/__nuxt-pages",
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/index.vue")
  },
  {
    name: "propietario-id",
    path: "/propietario/:id?",
    meta: _91_91id_93_93K9LDMmaYdWABMFM2Jibvq43atLGCLAwtx8w6batT_ecMeta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/propietario/[[id]].vue"),
    children: [
  {
    name: "propietario-id-menu-invita-seleccion",
    path: "menu/invita-seleccion",
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/propietario/[[id]]/menu/invita-seleccion/index.vue")
  },
  {
    name: "propietario-id-casa-cottageId-legal",
    path: "casa/:cottageId()/legal",
    meta: index_46clientuP3GCz1SRvEoFvNXyR2fvB9XMczh_qs9dkoZ0t_452NDAMeta || {},
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/pages/propietario/[[id]]/casa/[cottageId]/legal/index.client.vue"))
  },
  {
    name: "propietario-id-casa-cottageId-editar-fotos",
    path: "casa/:cottageId()/editar/fotos",
    meta: index_46clientGgsG7Wr1SigLg_45eSsbXepQKQToR_z9_45_45tEmCR3ovDGcMeta || {},
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/pages/propietario/[[id]]/casa/[cottageId]/editar/fotos/index.client.vue"))
  }
]
  },
  {
    name: "__nuxt-pages-errors",
    path: "/__nuxt-pages/errors",
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/errors.vue")
  },
  {
    name: "__nuxt-pages-health",
    path: "/__nuxt-pages/health",
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/health.vue")
  },
  {
    name: "accesibilidad",
    path: "/accesibilidad",
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/accesibilidad/index.vue")
  },
  {
    name: "casas-rurales",
    path: "/casas-rurales",
    meta: indexAH0y7NP_bUbvRQeaHdevtmDCqjl6d9ikCcT9TvUH8eIMeta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/casas-rurales/index.vue")
  },
  {
    name: "pueblos-slug",
    path: "/pueblos/:slug()",
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/pueblos/[slug]/index.vue")
  },
  {
    name: "destinos-slug",
    path: "/destinos/:slug()",
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/destinos/[slug]/index.vue")
  },
  {
    name: "__nuxt-pages-nuxt-ui-2",
    path: "/__nuxt-pages/nuxt-ui-2",
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/nuxt-ui-2.vue")
  },
  {
    name: "escapadas-slug",
    path: "/escapadas/:slug()",
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/escapadas/[slug]/index.vue")
  },
  {
    name: "viajero-registro",
    path: "/viajero/registro",
    meta: indexrRcrzY_45Rpy6nwggyE75xu3qc8jzYH841Jj6Fq_45VUotwMeta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/viajero/registro/index.vue")
  },
  {
    name: "__nuxt-pages-nuxt-image",
    path: "/__nuxt-pages/nuxt-image",
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/nuxt-image.vue")
  },
  {
    name: "vacaciones-slug",
    path: "/vacaciones/:slug()",
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/vacaciones/[slug]/index.vue")
  },
  {
    name: "politica-privacidad",
    path: "/politica-privacidad",
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/politica-privacidad/index.vue")
  },
  {
    name: design_45systemryTS8jm75JPnFdktbqAiDQv4Ehw_QQJLHmoRzOee5wYMeta?.name,
    path: "/__nuxt-pages/design-system",
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system.vue"),
    children: [
  {
    name: "__nuxt-pages-design-system",
    path: "",
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/index.vue")
  },
  {
    name: "__nuxt-pages-design-system-nuxt-ui-palette",
    path: "nuxt-ui/palette",
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/nuxt-ui/palette.vue")
  },
  {
    name: "__nuxt-pages-design-system-nuxt-ui-u-card",
    path: "nuxt-ui/u-card",
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/nuxt-ui/u-card.client.vue"))
  },
  {
    name: "__nuxt-pages-design-system-nuxt-ui-u-badge",
    path: "nuxt-ui/u-badge",
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/nuxt-ui/u-badge.client.vue"))
  },
  {
    name: "__nuxt-pages-design-system-nuxt-ui-u-input",
    path: "nuxt-ui/u-input",
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/nuxt-ui/u-input.client.vue"))
  },
  {
    name: "__nuxt-pages-design-system-nuxt-ui-u-button",
    path: "nuxt-ui/u-button",
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/nuxt-ui/u-button.client.vue"))
  },
  {
    name: "__nuxt-pages-design-system-components-t-prose",
    path: "components/t-prose",
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/components/t-prose.client.vue"))
  },
  {
    name: "__nuxt-pages-design-system-components-t-title",
    path: "components/t-title",
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/components/t-title.client.vue"))
  },
  {
    name: "__nuxt-pages-design-system-sections-s-section",
    path: "sections/s-section",
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/sections/s-section.client.vue"))
  },
  {
    name: "__nuxt-pages-design-system-nuxt-ui-u-accordion",
    path: "nuxt-ui/u-accordion",
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/nuxt-ui/u-accordion.client.vue"))
  },
  {
    name: "__nuxt-pages-design-system-sections-s-cta-card",
    path: "sections/s-cta-card",
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/sections/s-cta-card.client.vue"))
  },
  {
    name: "__nuxt-pages-design-system-sections-s-hero-card",
    path: "sections/s-hero-card",
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/sections/s-hero-card.client.vue"))
  },
  {
    name: "__nuxt-pages-design-system-sections-s-hero-angled",
    path: "sections/s-hero-angled",
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/sections/s-hero-angled.client.vue"))
  },
  {
    name: "__nuxt-pages-design-system-components-t-image-info",
    path: "components/t-image-info",
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/components/t-image-info.client.vue"))
  },
  {
    name: "__nuxt-pages-design-system-sections-s-media-banner",
    path: "sections/s-media-banner",
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/sections/s-media-banner.client.vue"))
  },
  {
    name: "__nuxt-pages-design-system-components-t-modal-close",
    path: "components/t-modal-close",
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/components/t-modal-close.client.vue"))
  },
  {
    name: "__nuxt-pages-design-system-sections-s-section-color",
    path: "sections/s-section-color",
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/sections/s-section-color.client.vue"))
  },
  {
    name: "__nuxt-pages-design-system-sections-s-section-split",
    path: "sections/s-section-split",
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/sections/s-section-split.client.vue"))
  },
  {
    name: "__nuxt-pages-design-system-sections-s-simple-banner",
    path: "sections/s-simple-banner",
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/sections/s-simple-banner.client.vue"))
  },
  {
    name: "__nuxt-pages-design-system-components-t-modal-header",
    path: "components/t-modal-header",
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/components/t-modal-header.client.vue"))
  },
  {
    name: "__nuxt-pages-design-system-sections-s-cta-color-image",
    path: "sections/s-cta-color-image",
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/sections/s-cta-color-image.client.vue"))
  },
  {
    name: "__nuxt-pages-design-system-sections-s-hero-card-search",
    path: "sections/s-hero-card-search",
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/design-system/sections/s-hero-card-search.client.vue"))
  }
]
  },
  {
    name: "__nuxt-pages-nuxt-ui",
    path: "/__nuxt-pages/nuxt-ui",
    component: () => createClientPage(() => import("/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/nuxt-ui.client.vue"))
  },
  {
    name: "propietario-casa-nueva",
    path: "/propietario/casa/nueva",
    meta: indexGcYxHWdflEQUpa1Q6JlKD3OgDb0_45iDcHXHgIsY1lKsoMeta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/propietario/casa/nueva/index.vue")
  },
  {
    name: "viajero-registro-optin",
    path: "/viajero/registro-optin",
    meta: indexzKRkF1TTuQMKZ54ykjXRuRySPRxn_Aeeo5pzmeOqzWQMeta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/viajero/registro-optin/index.vue")
  },
  {
    name: "__nuxt-pages-internal-traffic",
    path: "/__nuxt-pages/internal-traffic",
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/internal-traffic.vue")
  },
  {
    name: "como-funciona-la-plataforma",
    path: "/como-funciona-la-plataforma",
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/como-funciona-la-plataforma/index.vue")
  },
  {
    name: "todas-las-escapadas-rurales",
    path: "/todas-las-escapadas-rurales",
    meta: indexhYyMZ8ulIgZuhJ8fMrq_45iFRtagvujlqhdKb8iEDSy7AMeta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/todas-las-escapadas-rurales/index.vue")
  },
  {
    name: "casa-rural-province-slug",
    path: "/casa-rural/:province()/:slug()",
    meta: indexEUEkrSr21KN24VVeLH_45Ivdwp7yyo7ts2cY_vhI_45_eWgMeta || {},
    alias: indexEUEkrSr21KN24VVeLH_45Ivdwp7yyo7ts2cY_vhI_45_eWgMeta?.alias || [],
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/casa-rural/[province]/[slug]/index.vue")
  },
  {
    name: "casa-rural-province-slug-precios",
    path: "/casa-rural/:province()/:slug()/precios",
    meta: indexrfTw8l_b_45ky_gZdLUXkbfdLzn90z7WIvNir4_45lqJKF4Meta || {},
    alias: indexrfTw8l_b_45ky_gZdLUXkbfdLzn90z7WIvNir4_45lqJKF4Meta?.alias || [],
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/casa-rural/[province]/[slug]/precios/index.vue")
  },
  {
    name: "__nuxt-pages-cottages-recommended-id",
    path: "/__nuxt-pages/cottages/recommended/:id()",
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/cottages/recommended/[id]/index.vue")
  },
  {
    name: "reserva-online-como-activar-prueba-nuxt-1",
    path: "/reserva-online/como-activar/prueba-nuxt-1",
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/reserva-online/como-activar/prueba-nuxt-1/index.vue")
  },
  {
    name: "reserva-online-como-funciona-prueba-nuxt-1",
    path: "/reserva-online/como-funciona/prueba-nuxt-1",
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/reserva-online/como-funciona/prueba-nuxt-1/index.vue")
  },
  {
    name: "casa-rural-province-slug-solicitud-oferta-id",
    path: "/casa-rural/:province()/:slug()/solicitud/oferta/:id()",
    meta: _91id_93hOnUz_oYCzPOBe8dv5t8IH7zGbhrkN0_TjNADIdbZFQMeta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/casa-rural/[province]/[slug]/solicitud/oferta/[id].vue")
  },
  {
    name: "private-casa-rural-province-slug-telefono",
    path: "/private/casa-rural/:province()/:slug()/telefono",
    meta: indexM64GENOhODaGYggtTpuNmFlaG4UHH2TAeNuF8o6kzFEMeta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/private/casa-rural/[province]/[slug]/telefono/index.vue")
  },
  {
    name: indexOPPp4DpY6cQ0StbFh7gK9vmdPOD7EU_wbBwn7HnJ1NAMeta?.name ?? "__nuxt-pages-messages-whatsapp-id-page-erck",
    path: "/__nuxt-pages/messages/whatsapp/:id()/:page()/:erck()",
    meta: indexOPPp4DpY6cQ0StbFh7gK9vmdPOD7EU_wbBwn7HnJ1NAMeta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/__nuxt-pages/messages/whatsapp/[id]/[page]/[erck]/index.vue")
  },
  {
    name: "casa-rural-province-slug-solicitud-pre-reserva",
    path: "/casa-rural/:province()/:slug()/solicitud/pre-reserva",
    meta: indexmb_d_SJCCez8aNn6kP1wKYDl6WIZneqRUcDBg4arYbQMeta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/casa-rural/[province]/[slug]/solicitud/pre-reserva/index.vue")
  },
  {
    name: indexJZ13Q6OBqNiaqoLyl9iSJMCPt6nLEO70LnM7RCZ1jlAMeta?.name ?? "casa-rural-province-slug-solicitud-contacto-email",
    path: "/casa-rural/:province()/:slug()/solicitud/contacto-email",
    meta: indexJZ13Q6OBqNiaqoLyl9iSJMCPt6nLEO70LnM7RCZ1jlAMeta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/casa-rural/[province]/[slug]/solicitud/contacto-email/index.vue")
  },
  {
    name: "reserva-online-como-activar-prueba-nuxt-1-prueba-nuxt-2",
    path: "/reserva-online/como-activar/prueba-nuxt-1/prueba-nuxt-2",
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/reserva-online/como-activar/prueba-nuxt-1/prueba-nuxt-2/index.vue")
  },
  {
    name: "casa-rural-province-slug-solicitud-contacto-whatsapp",
    path: "/casa-rural/:province()/:slug()/solicitud/contacto-whatsapp",
    meta: indexTXG1bj9XnkPPEMLLxAKwNTYYTgnyWHFAZyqgCCY7d_45UMeta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/casa-rural/[province]/[slug]/solicitud/contacto-whatsapp/index.vue")
  },
  {
    name: "casa-rural-province-slug-solicitud-online-booking-id",
    path: "/casa-rural/:province()/:slug()/solicitud/online-booking/:id()",
    meta: indexmmQfCvEANtGCRoBR3DiEXuzlMUKOVnFO2i8OhZBikZkMeta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/casa-rural/[province]/[slug]/solicitud/online-booking/[id]/index.vue")
  },
  {
    name: "casa-rural-province-slug-solicitud-online-booking-id-payment-success",
    path: "/casa-rural/:province()/:slug()/solicitud/online-booking/:id()/payment-success",
    meta: indexTIt3qgXWY2wij0J_45Lox6dKOph4dD1p3xWs7Rwqe7iqYMeta || {},
    component: () => import("/builds/escapadarural/rurality-nuxt/pages/casa-rural/[province]/[slug]/solicitud/online-booking/[id]/payment-success/index.vue")
  }
]